import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    inheritAttrs: false,
    name: 'attachment-editor-dialog',
    components: { DialogTemplate },
})
export default class AttachmentEditorDialog extends Mixins<MixinInterface>() {
    @Prop() props!: any

    get fileObject() {
        return this.props.fileObject
    }

    get uploadingAttachment() {
        return this.props.uploadingAttachment
    }

    drawing = false
    originalContext
    context
    lastX = 0
    lastY = 0
    startX = 0
    startY = 0
    mouseX = 0
    mouseY = 0
    eraserOffsetTop = 0
    eraserOffsetLeft = 0
    drawingColor = '#212121'
    drawingStrokeWidth = 5
    imageObj
    drawingType = 'normal'
    drawingStates: any = []
    drawingStateIndex = -1
    showDrawingDot = false
    showColorPicker = false
    predefinedColors = [
        '#212121',
        '#607D8B',
        '#2196F3',
        '#4CAF50',
        '#B71C1C',

        '#FAFAFA',
        '#795548',
        '#00BCD4',
        '#FFEB3B',
        '#FF9800',
    ]

    mounted() {
        if (this.fileObject) {
            setTimeout(() => {
                this.initializeCanvas()
            }, 300)
        }
    }

    // STATES
    created() {
        window.addEventListener('keydown', this.keyDownHandler)
        window.addEventListener('wheel', this.handleMouseWheel)
    }
    destroyed() {
        window.removeEventListener('keydown', this.keyDownHandler)
        window.removeEventListener('wheel', this.handleMouseWheel)
    }

    initializeCanvas() {
        try {
            this.originalContext = (this.$refs.originalCanvas as HTMLCanvasElement).getContext(
                '2d',
                { willReadFrequently: true }
            )
            this.context = (this.$refs.canvas as HTMLCanvasElement).getContext('2d', {
                willReadFrequently: true,
            })
            // Load the image
            this.imageObj = new Image()
            this.imageObj.src = URL.createObjectURL(this.fileObject) // Replace with the actual image path
            this.imageObj.onload = () => {
                // Set canvas size based on the image size
                const { width, height } = this.calculateAspectRatioFit(
                    this.imageObj.width,
                    this.imageObj.height
                )

                ;(this.$refs.originalCanvas as HTMLCanvasElement).width = width
                ;(this.$refs.originalCanvas as HTMLCanvasElement).height = height
                ;(this.$refs.canvas as HTMLCanvasElement).width = width
                ;(this.$refs.canvas as HTMLCanvasElement).height = height

                this.originalContext.drawImage(this.imageObj, 0, 0, width, height)

                this.context.drawImage(this.$refs.canvas, 0, 0, width, height)
                // Draw the image on the canvas
            }
            // this.draftCanvasImage = new Image();
            // this.draftCanvasImage.src = URL.createObjectURL(this.fileObject);
        } catch (e) {
            //
        }
    }
    pointerInsideEditor(_event) {
        this.showDrawingDot = true
        this.displayLineWidthPreview(this.mouseX, this.mouseY)
    }
    pointerOutsideEditor(_event) {
        this.showDrawingDot = false
        this.displayLineWidthPreview(this.mouseX, this.mouseY)
    }

    startDrawing(event) {
        if (this.showColorPicker) {
            this.showColorPicker = false
        }
        this.drawing = true
        const rect = (this.$refs.canvas as HTMLCanvasElement).getBoundingClientRect()
        const x = event.clientX - rect.left
        const y = event.clientY - rect.top
        ;[this.lastX, this.lastY] = [x, y]

        if (this.drawingType !== 'normal' && this.drawingType !== 'eraser') {
            this.startX = x
            this.startY = y
        }
        this.draw(event)
    }
    draw(event) {
        const rect = (this.$refs.canvas as HTMLCanvasElement).getBoundingClientRect()
        const x = event.clientX - rect.left
        const y = event.clientY - rect.top
        this.mouseX = x
        this.eraserOffsetLeft = x + (this.$refs.canvas as HTMLCanvasElement).offsetLeft
        this.mouseY = y
        this.eraserOffsetTop = y + (this.$refs.canvas as HTMLCanvasElement).offsetTop
        if (!this.drawing) {
            this.displayLineWidthPreview(x, y)
            return
        }

        switch (this.drawingType) {
            case 'normal':
            case 'eraser':
                this.drawLine(x, y)
                break
            case 'rectangle':
                this.drawRectangle(x, y)
                break
            case 'circle':
                this.drawCircle(x, y)
                break
            case 'ellipse':
                this.drawEllipse(x, y)
                break
            case 'arrow':
                this.drawArrow(x, y)
            default:
                this.drawLine(x, y)
                break
        }
    }
    drawLine(x, y) {
        this.context.beginPath()
        this.context.moveTo(this.lastX, this.lastY)
        this.context.lineTo(x, y)
        this.context.strokeStyle = this.drawingColor
        this.context.globalCompositeOperation =
            this.drawingType === 'eraser' ? 'destination-out' : 'source-over'
        this.context.lineWidth = this.drawingStrokeWidth
        this.context.lineCap = 'round'
        this.context.lineJoin = 'round'
        this.context.stroke()
        ;[this.lastX, this.lastY] = [x, y]
    }
    drawCircle(x, y) {
        this.refreshDrawing()
        const radius = Math.sqrt(Math.pow(x - this.startX, 2) + Math.pow(y - this.startY, 2))
        this.context.beginPath()
        this.context.arc(this.startX, this.startY, radius, 0, 2 * Math.PI, false)
        this.context.strokeStyle = this.drawingColor
        this.context.stroke()
        this.context.lineWidth = this.drawingStrokeWidth
        this.context.fillStyle = this.drawingColor
        this.context.fill()
        this.context.stroke()
    }
    drawRectangle(x, y) {
        this.refreshDrawing()
        const rectWidth = x - this.startX
        const rectHeight = y - this.startY
        this.context.beginPath()
        this.context.strokeStyle = this.drawingColor
        this.context.lineWidth = this.drawingStrokeWidth
        this.context.rect(this.startX, this.startY, rectWidth, rectHeight)
        this.context.fillStyle = this.drawingColor
        this.context.fillRect(this.startX, this.startY, rectWidth, rectHeight)
        this.context.stroke()
    }
    drawEllipse(x, y) {
        this.refreshDrawing()
        const fromX = (this.startX + x) / 2
        const fromY = (this.startY + y) / 2
        const radiusX = Math.abs(this.startX - x) / 2
        const radiusY = Math.abs(this.startY - y) / 2
        const angle = 0
        const startAngle = 0
        const endAngle = 2 * Math.PI

        this.context.beginPath()
        this.context.ellipse(fromX, fromY, radiusX, radiusY, angle, startAngle, endAngle)
        this.context.strokeStyle = this.drawingColor
        this.context.lineWidth = this.drawingStrokeWidth
        this.context.fillStyle = this.drawingColor
        this.context.fill()
        this.context.stroke()
    }
    drawArrow(x, y) {
        this.refreshDrawing()
        this.context.beginPath()
        this.context.moveTo(this.startX, this.startY)
        this.context.lineTo(x, y)
        this.context.strokeStyle = this.drawingColor
        this.context.lineWidth = this.drawingStrokeWidth
        this.context.stroke()

        const angle = Math.atan2(y - this.startY, x - this.startX)
        const arrowHead1 = {
            x: x - this.drawingStrokeWidth * 3 * Math.cos(angle - Math.PI / 6),
            y: y - this.drawingStrokeWidth * 3 * Math.sin(angle - Math.PI / 6),
        }
        const arrowHead2 = {
            x: x - this.drawingStrokeWidth * 3 * Math.cos(angle + Math.PI / 6),
            y: y - this.drawingStrokeWidth * 3 * Math.sin(angle + Math.PI / 6),
        }

        this.context.beginPath()
        this.context.moveTo(arrowHead1.x, arrowHead1.y)
        this.context.lineTo(x, y)
        this.context.lineTo(arrowHead2.x, arrowHead2.y)
        this.context.strokeStyle = this.drawingColor
        this.context.lineWidth = this.drawingStrokeWidth
        this.context.stroke()
    }
    stopDrawing() {
        this.drawing = false
        const imageData = this.context.getImageData(
            0,
            0,
            (this.$refs.canvas as HTMLCanvasElement).width,
            (this.$refs.canvas as HTMLCanvasElement).height
        )
        if (this.drawingStateIndex === this.drawingStates.length - 1) {
            // add new draw
            this.drawingStateIndex++
            this.drawingStates.push(imageData)
        } else {
            // handle drawing after undo/redo
            this.drawingStates = this.drawingStates.slice(0, this.drawingStateIndex + 1)
            this.drawingStateIndex++
            this.drawingStates.push(imageData)
        }
        setTimeout(() => {
            this.context.putImageData(imageData, 0, 0)
        }, 50)
    }
    refreshDrawing() {
        this.context.clearRect(
            0,
            0,
            (this.$refs.canvas as HTMLCanvasElement).width,
            (this.$refs.canvas as HTMLCanvasElement).height
        )
        // const { width, height } = this.calculateAspectRatioFit(this.imageObj.width, this.imageObj.height, 600, 600);
        // this.context.drawImage(this.draftCanvasImage, 0, 0, width, height);
        const imageData = this.drawingStates[this.drawingStateIndex]
        if (imageData) {
            this.context.putImageData(this.drawingStates[this.drawingStateIndex], 0, 0)
        }
    }
    clearDrawing() {
        const { width, height } = this.calculateAspectRatioFit(
            this.imageObj.width,
            this.imageObj.height
        )
        this.context.drawImage(this.imageObj, 0, 0, width, height)
        // this.draftCanvasImage.src = URL.createObjectURL(this.fileObject);
    }
    resetCanvas() {
        this.context = null
        this.lastX = 0
        this.lastY = 0
        this.startX = 0
        this.startY = 0
        this.drawingColor = '#000000'
        this.drawingStrokeWidth = 5
        this.drawingType = 'normal'
        this.imageObj = null
        // this.draftCanvasImage = null;
        this.drawingStates = []
        this.drawingStateIndex = -1
    }
    onChangeDrawingColor(selectedColor) {
        this.drawingColor = selectedColor
        this.showColorPicker = false
        this.displayLineWidthPreview(this.mouseX, this.mouseY)
    }
    // onChangeDrawingStrokeWidth(event) {
    //     this.drawingStrokeWidth = event.target.value;
    // }
    onHideEditor() {
        this.resetCanvas()
        this.$emit('onHide')
    }
    onSaveAttachment() {
        const { width, height } = this.calculateAspectRatioFit(
            this.imageObj.width,
            this.imageObj.height
        )
        this.originalContext.drawImage(this.$refs.canvas, 0, 0, width, height)

        setTimeout(() => {
            ;(this.$refs.originalCanvas as HTMLCanvasElement).toBlob((blob) => {
                if (blob) {
                    const file = new File([blob], 'test.jpg', {
                        type: 'image/jpg',
                        lastModified: Date.now(),
                    })
                    // const link = document.createElement('a');
                    // link.href = URL.createObjectURL(blob);
                    // link.setAttribute('download', 'jpg');
                    // document.body.appendChild(link);
                    // link.click();
                    this.$emit('close', file)
                }
            }, 'image/jpg')
        }, 300)
    }

    changeDrawingType(type) {
        if (this.drawingType === type) {
            this.drawingType = 'normal'
        } else {
            this.drawingType = type
        }
        this.displayLineWidthPreview(this.mouseX, this.mouseY)
    }

    calculateAspectRatioFit(srcWidth, srcHeight) {
        let maxWidth = (this.$refs.canvasContainer as HTMLDivElement).offsetWidth
        let maxHeight = (this.$refs.canvasContainer as HTMLCanvasElement).offsetHeight
        const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
        return { width: srcWidth * ratio, height: srcHeight * ratio }
    }

    setStrokeWidth(width) {
        this.drawingStrokeWidth = width
    }
    getStrokeWidth() {
        // const strokeData = this.lineWidths.find(item => item.value === this.drawingStrokeWidth);
        // return strokeData ? strokeData.size : this.lineWidths[0].size;
        return this.drawingStrokeWidth
    }
    undoDrawing() {
        this.drawingStateIndex--
        if (this.drawingStateIndex > -1) {
            this.context.putImageData(this.drawingStates[this.drawingStateIndex], 0, 0)
        } else {
            this.context.clearRect(
                0,
                0,
                (this.$refs.canvas as HTMLCanvasElement).width,
                (this.$refs.canvas as HTMLCanvasElement).height
            )
            this.drawingStateIndex = -1
        }
    }
    redoDrawing() {
        if (this.drawingStateIndex < this.drawingStates.length - 1) {
            this.drawingStateIndex++
            this.context.putImageData(this.drawingStates[this.drawingStateIndex], 0, 0)
        }
    }

    keyDownHandler(event: any) {
        event.stopPropagation()
        event.preventDefault()
        if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
            this.undoDrawing()
        }
        if (
            ((event.ctrlKey || event.metaKey) && event.key === 'y') ||
            ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z')
        ) {
            this.redoDrawing()
        }
    }
    displayLineWidthPreview(x, y) {
        this.context.clearRect(
            0,
            0,
            (this.$refs.canvas as HTMLCanvasElement).width,
            (this.$refs.canvas as HTMLCanvasElement).height
        )
        const latestImgData = this.drawingStates[this.drawingStateIndex]
        if (latestImgData) {
            this.context.putImageData(latestImgData, 0, 0)
        }
        if (this.showDrawingDot) {
            this.context.beginPath()
            this.context.arc(x, y, this.drawingStrokeWidth / 2, 0, 2 * Math.PI)
            this.context.lineWidth = this.drawingStrokeWidth
            this.context.lineCap = 'round'
            this.context.lineJoin = 'round'
            if (this.drawingType !== 'eraser') {
                this.context.globalCompositeOperation = 'source-over'
                this.context.strokeStyle = this.drawingColor
                this.context.fillStyle = this.drawingColor
            } else {
                this.context.globalCompositeOperation = 'destination-out'
                this.context.lineWidth = 2
                this.context.strokeStyle = '#000000'
                this.context.fillStyle = 'transparent'
                this.context.stroke()
            }
            this.context.fill()
        }
    }
    handleMouseWheel(event) {
        if (!this.showDrawingDot) {
            return
        }
        if (event.deltaY > 0) {
            // decrease line width
            if (this.drawingStrokeWidth > 1) {
                this.drawingStrokeWidth--
            }
        } else {
            // increase line width
            if (this.drawingStrokeWidth <= 31) {
                this.drawingStrokeWidth++
            }
        }
        this.displayLineWidthPreview(this.mouseX, this.mouseY)
    }
    handleChangeDrawingStrokeWidth(value) {
        this.drawingStrokeWidth = value
        this.displayLineWidthPreview(this.mouseX, this.mouseY)
    }
}
